



























import Enumerable from "linq";
import { ElTree } from "element-ui/types/tree";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Directory, RootDirectory } from "../../../../domain/drawing";
import { ITreeCollapsable, ITreeExpandable } from "../../../system";
import { ModelEditableMixin } from "../../../system/mixins";
import {
  FormatSet,
  IFormatSetTreeNode,
  IFormatSetTreeData
} from "../../../../domain/format";
import { DirectoryTreeNodesFactory } from "../../../system/utilities/DirectoryTreeNodesFactory";
import { FormatTreeNodeUtility } from "./utilities";

@Component({
})
export default class FormatSetReferencesTreeSelector extends Mixins(ModelEditableMixin) implements ITreeExpandable, ITreeCollapsable {
  data(): any {
    return {
      selectedNode: null as IFormatSetTreeNode,
    };
  }
  selectedNode: IFormatSetTreeNode;

  @Prop()
  rootDirectory: RootDirectory<string, FormatSet>;

  @Prop()
  filter: (source: FormatSet | Directory<string, FormatSet>) => boolean;

  @Watch("rootDirectory")
  onRootDirectoryUpdated(newValue: RootDirectory<string, FormatSet>[], oldValue: RootDirectory<string, FormatSet>[]) {
    this.clearSelection();
  }

  private clearSelection(): void {
    this.editingSource = [];
    this.onFormatSetSelectionChanged(null);
    this.selectedNode = null;
  }

  get isLoaded(): boolean {
    const nodes = this.createNodes(this.rootDirectory);
    return !!nodes && (0 < nodes.length);
  }

  private createNodes(rootDirectory: RootDirectory<string, FormatSet>): IFormatSetTreeData[] {
    // thisをバインドしておかないと実行時のthisが変わるのでアロー関数でバインド.
    const factory = new DirectoryTreeNodesFactory(
      (e: FormatSet, i: number) => FormatSetReferencesTreeSelector._nodeUtility.toFormatSetNode(e, i));
    return factory.createFromRootDirectory(rootDirectory);
  }

  private static readonly _nodeUtility = new FormatTreeNodeUtility();

  getTreeComponent(): ElTree<string, IFormatSetTreeData> {
    return this.$refs.tree as ElTree<string, IFormatSetTreeData>;
  }

  expandTree(): void {
    if (!this.isLoaded) {
      return;
    }
    FormatSetReferencesTreeSelector._nodeUtility.expandNode((this.getTreeComponent() as any).root); // rootが必要なのでanyに変換
  }

  collapseTree(): void {
    if (!this.isLoaded) {
      return;
    }
    FormatSetReferencesTreeSelector._nodeUtility.collapseNode((this.getTreeComponent() as any).root); // rootが必要なのでanyに変換
  }

  updateNodeExpand(node: IFormatSetTreeData, nodeProperty: IFormatSetTreeNode, nodeSelf: any): void {
    FormatSetReferencesTreeSelector._nodeUtility.updateNodeExpanded(node, nodeProperty, nodeSelf);
  }

  handleNodeClicked(node: IFormatSetTreeData, nodeProperty: IFormatSetTreeNode, nodeSelf: any): void {
    const source = node.source;
    if (source instanceof FormatSet) {
      this.editingSource = source.formats;
      this.onFormatSetSelectionChanged(source);
    } else {
      this.editingSource = [];
      this.onFormatSetSelectionChanged(null);
    }
    this.selectedNode = nodeProperty;
  }

  @Emit("nodeDoubleClicked")
  nodeDoubleClicked(): void {}

  handleNodeDoubleClicked(event: PointerEvent): void {
    if (this.selectedNode.data.source instanceof FormatSet) {
      this.nodeDoubleClicked();
    }
    if (this.selectedNode.data.source instanceof Directory) {
      // 開閉反転
      // el-treeのexpand-on-click-nodeをfalseにしないと開閉が激しい・・
      // this.selectedNode.expanded = !this.selectedNode.expanded;
    }
  }

  @Emit("formatSetSelectionChanged")
  onFormatSetSelectionChanged(value: FormatSet): void {}

  @Watch("filter")
  onFilterUpdated(): void {
    this.clearSelection();
  }

  get filteredNodes(): IFormatSetTreeData[] {
    return Enumerable.from(this.createNodes(this.rootDirectory))
      .where(d => this.filterNode(this.filter, d, false))
      .where(d => this.filterRootFormatSet(this.filter, d))
      .toArray();
  }

  private filterNode(filter: (source: FormatSet | Directory<string, FormatSet>) => boolean, data: IFormatSetTreeData, isAncestorDirectoryMatched: boolean): boolean {
    const isDirectoryMatched = (data.source instanceof Directory) && filter(data.source);
    data.children = Enumerable.from(data.children)
      .where(c => this.filterNode(filter, c, isAncestorDirectoryMatched || isDirectoryMatched))
      .toArray();

    if (data.source instanceof FormatSet) {
      // フォーマットが無い文書セットを表示しても意味が無いので非表示としている（フォーマット自体は絞り込みしていない）
      if (data.source.formats.length === 0) {
        return false;
      }
    }
    if (data.source instanceof Directory) {
      if (data.children.length === 0) {
        return false;
      }
      if (isAncestorDirectoryMatched) {
        // 途中のフォルダが一致しているときは制限なく表示する
        return true;
      }
      // 配下にフォルダがある場合は自分が条件に一致しているかどうかに関わらず表示が必要
      // ただし、自分が条件に一致していない場合は直下の文書セットは非表示とする
      if (Enumerable.from(data.children).any(c => c.source instanceof Directory)) {
        if (!filter(data.source)) {
          data.children = Enumerable.from(data.children)
            .where(c => c.source instanceof Directory)
            .toArray();
        }
        return true;
      }
    }
    return filter(data.source);
  }

  /**
   * フォルダ指定されたときにルート直下のフォーマットセットを非表示にするフィルタ処理
   */
  private filterRootFormatSet(filter: (source: FormatSet | Directory<string, FormatSet>) => boolean, data: IFormatSetTreeData): boolean {
    if (data.source instanceof Directory) { return true; }
    // 無名のフォルダが一致するのであればフォルダ名称でのフィルタが無いと判定している
    const directory = new Directory<string, FormatSet>("", "", [], []);
    return filter(directory);
  }
}
